export default __webpack_public_path__ + "static/theoldhemp-328d113e78aefe54ce2d7400f2045092.svg";